import { api } from 'data/api/api'

import { GetEscrowOrderItemsResp } from '../types/dtos/escrow-order-item'
import { GetRefundResp } from '../types/dtos/get-refund-resp'
import { ReuploadItemResp } from '../types/dtos/reupload-item'

export const getEscrowOrderItems = (orderId: number) =>
  api.get<GetEscrowOrderItemsResp>(`/escrow_orders/${orderId}/items`)

export const getRefund = (transactionId: number) =>
  api.get<GetRefundResp>(`/transactions/${transactionId}/refund`)

export const reuploadItem = (id: number) =>
  api.post<ReuploadItemResp>(`/transactions/${id}/reupload`)
